module.exports = __webpack_public_path__ + "static/images/vip-start-info.png?v=087b6d2";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/images/vip-start-info.png
// module id = vje7
// module chunks = 1